module.exports = __webpack_public_path__ + "static/img/use_zoom.6840057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/use_zoom.png
// module id = Fp4Y
// module chunks = 4